import {
  VStack,
  Textarea,
  Button,
  HStack,
  Text,
  Card,
  CardBody,
  useToast,
} from '@chakra-ui/react'
import { useState } from 'react'
import { MdSave, MdEdit } from 'react-icons/md'

export default function NotesPanel() {
  const [notes, setNotes] = useState('')
  const [savedNotes, setSavedNotes] = useState('')
  const toast = useToast()

  const handleSave = () => {
    setSavedNotes(notes)
    toast({
      title: 'Notes saved',
      description: 'Your notes have been saved successfully',
      status: 'success',
      duration: 2000,
      isClosable: true,
    })
  }

  const hasUnsavedChanges = notes !== savedNotes

  return (
    <VStack spacing={4} align="stretch" h="100%">
      {/* Info Card */}
      <Card bg="blue.50" borderColor="blue.200" borderWidth={1}>
        <CardBody>
          <HStack spacing={2}>
            <MdEdit style={{ fontSize: '20px', color: 'var(--chakra-colors-blue-500)' }} />
            <Text fontSize="sm" color="blue.800">
              Use this space to add your observations, annotations, or clinical notes about this analysis.
            </Text>
          </HStack>
        </CardBody>
      </Card>

      {/* Notes Textarea */}
      <Textarea
        placeholder="Add your notes here...

Example:
- Patient symptoms
- Visual observations
- Differential diagnosis
- Recommended follow-up
- Treatment plan"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        flex={1}
        resize="none"
        fontSize="sm"
        bg="white"
        _focus={{
          borderColor: 'purple.400',
          boxShadow: '0 0 0 1px var(--chakra-colors-purple-400)',
        }}
      />

      {/* Character Count */}
      <Text fontSize="xs" color="gray.500" textAlign="right">
        {notes.length} characters
      </Text>

      {/* Save Button */}
      <Button
        leftIcon={<MdSave />}
        colorScheme="purple"
        onClick={handleSave}
        isDisabled={!hasUnsavedChanges}
      >
        {hasUnsavedChanges ? 'Save Notes' : 'Notes Saved'}
      </Button>

      {/* Saved Notes Preview (if exists) */}
      {savedNotes && !hasUnsavedChanges && (
        <Card bg="green.50" borderColor="green.200" borderWidth={1}>
          <CardBody>
            <VStack align="stretch" spacing={2}>
              <Text fontSize="xs" fontWeight="semibold" color="green.700">
                ✓ Last saved notes:
              </Text>
              <Text fontSize="sm" color="gray.700" noOfLines={3}>
                {savedNotes}
              </Text>
            </VStack>
          </CardBody>
        </Card>
      )}
    </VStack>
  )
}
